import { useEffect } from 'react';
import { useChangeEffect, cssTransitionSelectors } from '@utils/react';
import { content } from './_component.style.js';
import { useCurrentTaskEntry } from './state/hook.entry.js';
import { useCurrentLocation } from './state/hook.location.js';

/**
 * Ensures that the focus is correctly reset to the root of the component every
 * time navigation between tasks/views occurs.
 */
function useFocusManagement(ref, args) {
  const currentPageId = useCurrentLocation();
  const currentEntry = useCurrentTaskEntry();

  //
  // NB: When transitioning from our collapsed harmonica to our expanded
  // component in PM2, then the content should be automatically focused.
  //
  useEffect(() => {
    if (!args.isExpandedHarmonica) {
      return;
    }
    ref.current?.focus({
      preventScroll: true
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //
  // NB: When changing pages, then we should move focus back to the start of
  // the content
  //
  useChangeEffect(() => {
    setTimeout(() => {
      const focusTarget = ref.current?.querySelector(`.${content}:not(${cssTransitionSelectors.isExiting()}) [data-focus-content='true']`) ?? ref.current;
      focusTarget?.focus({
        preventScroll: true
      });
    }, 200);
  }, [currentEntry?.id, currentEntry?.state.attempts, currentPageId]);
}

export { useFocusManagement };
//# sourceMappingURL=hook.focus-management.js.map
